import { paymentService } from 'services/payment/paymentService';
import { PaymentConfigDto } from 'services/payment/paymentService.dto';

import { getFromSessionOrFetch, parseMaxAgeSeconds } from './getFromSessionOrFetch';

export const PAYMENT_CONFIG_STORAGE_KEY = 'paymentConfig';

const readCacheControl = (headers: unknown): string | undefined => {
  if (!headers || typeof headers !== 'object') return undefined;

  const headerMap = headers as Record<string, unknown> & { get?: (name: string) => unknown };

  if (typeof headerMap.get === 'function') {
    const value = headerMap.get('cache-control');
    return typeof value === 'string' ? value : undefined;
  }

  const value = headerMap['cache-control'];
  return typeof value === 'string' ? value : undefined;
};

export const fetchPaymentConfigFromSessionOrBackend = (): Promise<PaymentConfigDto> =>
  getFromSessionOrFetch(PAYMENT_CONFIG_STORAGE_KEY, async () => {
    const response = await paymentService.fetchClientConfiguration('USD');

    return {
      data: response.data,
      maxAgeSeconds: parseMaxAgeSeconds(readCacheControl(response.headers)),
    };
  });
